<template>
  <v-container fluid fill-height class="container-poll pa-8">
    <v-row no-gutters justify="center" align="center">
      <v-col
        v-if="currentClip.contentData.pollQuestion"
        cols="12"
        align-self="center"
        class="container-poll-title text-center"
      >
        <span class="txt-poll-title">{{ currentClip.contentData.pollQuestion }}</span>
      </v-col>
      <v-col class="txt-total-votes mt-2 mb-5" cols="12">
        <span>Total {{ totalVoters }} voted</span>
      </v-col>
      <v-col cols="12" align="center">
        <v-row v-if="!isVoted" class="container-poll-cotents" no-gutters justify="center" align="center">
          <v-col cols="12" class="content-text">
            <v-row class="overflow-y-auto mt-4" no-gutters>
              <v-card
                v-for="(item, index) in currentClip.contentData.pollChoices"
                :key="index"
                width="100%"
                flat
                color="#31434f"
                class="px-5 py-2 mb-3 card-choice"
              >
                <v-row no-gutters align="center" justify="space-between" @click="setSelectedChoice(index)">
                  <v-col>
                    <span class="txt-poll-contents" style="line-height: 26px">{{ item.title }}</span>
                  </v-col>
                  <v-col cols="auto">
                    <v-icon v-if="selectedList.includes(index)" color="primary">mdi-check</v-icon>
                  </v-col>
                </v-row>
              </v-card>
            </v-row>
            <v-row no-gutters>
              <v-col class="btn-vote mt-4" align="center" no-gutters>
                <v-btn
                  color="rgb(40, 144, 103)"
                  width="100"
                  block
                  :disabled="!selectedList || selectedList.length === 0"
                  :loading="isVoteLoading"
                  @click="setVote()"
                >
                  {{ $t('vote') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row v-else no-gutters class="container-poll-cotents" justify="center" align="center">
          <v-card
            v-for="(item, index) in currentClip.contentData.pollChoices"
            :key="index"
            width="100%"
            flat
            color="transparent"
            class="mb-6 card-choice-result"
          >
            <span class="txt-poll-contents">{{ item.title }}</span>
            <v-progress-linear
              background-color="#1a272e"
              class="mt-2"
              rounded
              :value="(item.voterList.length / totalVotes) * 100"
              height="42"
            >
              <span class="txt-poll-contents" style="width: 100%; text-align: start; padding-left: 8px">
                {{ Math.floor((item.voterList.length / totalVotes) * 100) }}% ({{ item.voterList.length }})
              </span>
            </v-progress-linear>

            <attendee
              class="mt-2"
              :mtOrganizerUid.sync="currentMt.mtOrganizerUid"
              :list.sync="item.voterList"
              :isAdd="false"
              :size="'26'"
              :isDisableCrown="true"
              :deleteOrgarnizer="false"
            ></attendee>
          </v-card>

          <v-row no-gutters>
            <v-col class="btn-vote-again" align="center" no-gutters>
              <v-btn color="#21343b" width="100" block :loading="isVoteAgainLoading" @click="setVoteAgain()">
                {{ $t('voteAgain') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-row>
      </v-col>
    </v-row>
    <guest-in v-if="guestInVisible" @close="closeGuestIn" :guestInVisible.sync="guestInVisible"></guest-in>
  </v-container>
</template>

<script>
import { setVoteUpdate } from '@/services/clipApi'
import { mapGetters } from 'vuex'
import Attendee from '@/views/meeting/component/card/Attendee'
import GuestIn from '@/views/modal/GuestIn'

export default {
  created() {},
  components: { Attendee, GuestIn },
  data() {
    return {
      isVoteLoading: false,
      isVoteAgainLoading: false,
      selectedList: [],
      guestInVisible: false,
    }
  },
  methods: {
    closeGuestIn() {
      this.guestInVisible = false
      if (this.userInfo && this.userInfo !== null) {
        this.setVote()
      }
    },
    setSelectedChoice(index) {
      let idx = this.selectedList.findIndex((i) => i === index)
      if (idx >= 0) this.selectedList.splice(idx, 1)
      else this.selectedList.push(index)
    },
    async setVote() {
      if (!this.userInfo || this.userInfo === null) {
        this.$store.dispatch('setSignInRedirectUrl', location.pathname)
        this.guestInVisible = true
      } else {
        this.isVoteLoading = true
        const voterData = {
          userDisplayName: this.userInfo.userDisplayName,
          userEmail: this.userInfo.userEmail,
          userFullName: this.userInfo.userFullName,
          userId: this.userInfo.userId,
          userPicture: this.userInfo.userPicture,
        }

        const contentData = {
          pollChoices: this.currentClip.contentData.pollChoices,
          pollQuestion: this.currentClip.contentData.pollQuestion,
          type: this.currentClip.contentData.type,
        }
        for (let index of this.selectedList) {
          contentData.pollChoices[index].voterList.push(voterData)
          // this.currentClip.contentData.pollChoices[index].voterList.push(voterData)
        }

        try {
          await setVoteUpdate(this, this.currentMt.wsId, this.currentMt.mtId, this.currentClip.clipId, contentData)
        } catch (error) {
          console.log(error)
        } finally {
          // await this.$store.dispatch('setIsLoading', false)
          this.isVoteLoading = false
          this.selectedList = []
          this.currentClip.contentData = contentData
        }
      }
    },
    async setVoteAgain() {
      let ctx = this
      this.isVoteAgainLoading = true

      const contentData = {
        pollChoices: this.currentClip.contentData.pollChoices,
        pollQuestion: this.currentClip.contentData.pollQuestion,
        type: this.currentClip.contentData.type,
      }

      for (let pollChoice of contentData.pollChoices) {
        let index = pollChoice.voterList.findIndex((voter) => voter.userId === ctx.userInfo.userId)
        if (index >= 0) pollChoice.voterList.splice(index, 1)
      }

      try {
        await setVoteUpdate(this, this.currentMt.wsId, this.currentMt.mtId, this.currentClip.clipId, contentData)
      } catch (error) {
        console.log(error)
      } finally {
        // await this.$store.dispatch('setIsLoading', false)
        this.isVoteAgainLoading = false
        this.currentClip.contentData = contentData
      }
    },
  },
  computed: {
    ...mapGetters(['userInfo', 'currentMt', 'currentClip']),
    isVoted() {
      let isVoted = false
      let ctx = this
      if (this.currentClip.contentData.pollChoices && this.userInfo) {
        let index = this.currentClip.contentData.pollChoices.findIndex((pollChoice) => {
          let idx = pollChoice.voterList.findIndex((voter) => voter.userId === ctx.userInfo.userId)
          return idx >= 0
        })
        isVoted = index >= 0
      }
      return isVoted
    },
    totalVoters() {
      let voterIdList = []
      for (let pollChoices of this.currentClip.contentData.pollChoices) {
        if (pollChoices.voterList && pollChoices.voterList.length > 0) {
          voterIdList = [...voterIdList, ...pollChoices.voterList.map((voter) => voter.userId)]
        }
      }
      return [...new Set(voterIdList)].length
    },
    totalVotes() {
      let count = 0
      for (let pollChoices of this.currentClip.contentData.pollChoices) {
        if (pollChoices.voterList && pollChoices.voterList.length > 0) count += pollChoices.voterList.length
      }
      return count
    },
  },
}
</script>

<style scoped>
.container-poll {
  display: flex;
  background-color: transparent;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 140px);
}
@media (max-width: 1263px) {
  .container-poll {
    border-radius: 0 0 10px 10px;
    overflow: unset;
    padding-bottom: 100px !important;
  }
}
/* @media (max-width: 1263px) {
  .container-poll {
  }
} */
.container-poll-title {
  /* max-width: 1000px; */
}
.container-poll-cotents {
  max-width: 500px;
}
.card-choice {
  color: #eee;
  font-size: 1.1rem;
  border-radius: 10px;
  text-align: start;
  cursor: pointer;
}
.card-choice-result {
  color: #eee;
  font-size: 1.1rem;
  text-align: start;
}
.content-text {
  color: #eee;
  font-size: 1.8rem;
}
.txt-total-votes {
  text-align: right;
  color: #96a7af;
  font-size: 14px;
  max-width: 500px;
}
.txt-poll-title {
  color: #eee;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -1px;
  word-break: break-all;
  /* display: block; */
  /* overflow-y: auto; */
  /* max-height: 100px; */
}

.txt-poll-contents {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #fff;
  display: block;
  overflow-y: auto;
  padding-top: 2px;
  padding-bottom: 2px;
}
.btn-vote >>> .v-btn * {
  font-size: 14px;
  letter-spacing: 0;
  text-transform: none;
  color: white;
  font-weight: bold;
}
.btn-vote-again >>> .v-btn * {
  font-size: 14px;
  letter-spacing: 0;
  text-transform: none;
  color: #27cd8b;
  font-weight: bold;
}
</style>
